import axios, { AxiosInstance } from 'axios';

export interface RequestOptions {
    hndlWafError: (code: string, error: string) => void;
    hndlRequestError: (error: string) => void;
    hndlWafMessage: (error: string) => void;
    getSessionId: () => string;
    baseURL: string;
    sendMailURL: string;
}

class RequestClass {
    private hndlWafError: (code: string, error: string) => void;
    private hndlRequestError: (error: string) => void;
    private hndlWafMessage: (error: string) => void;
    private getSessionId: () => string;
    private axiosRequest: AxiosInstance;
    private axiosSendMail: AxiosInstance | undefined;

    constructor(options: RequestOptions) {
        this.hndlWafError = options.hndlWafError;
        this.hndlRequestError = options.hndlRequestError;
        this.hndlWafMessage = options.hndlWafMessage;
        this.getSessionId = options.getSessionId;

        this.axiosRequest = axios.create({
            baseURL: options.baseURL || '/datasling/execute/',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (options.sendMailURL) {
            this.axiosSendMail = axios.create({
                baseURL: options.sendMailURL,
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        }
    }

    // SOURCE: https://dimitrioslytras.com/vue-error-handling/
    //         https://codesandbox.io/s/91132rm8kp?from-embed
    public execute(proc: string, data = {}, config = { scalar: false }) {
        return this.internalExecution(this.axiosRequest, proc, data, config);
    }

    public scalar(proc: string, data: object) {
        return this.execute(proc, data, { scalar: true });
    }

    public sendMail(data = {}) {
        if (this.axiosSendMail) {
            return this.internalExecution(this.axiosSendMail, 'send', data, { scalar: true });
        } else {
            return false;
        }
    }

    private internalExecution(instance: AxiosInstance, proc: string, data = {}, config = { scalar: false }) {
        return instance
            .post(proc, data, { params: { SESSIONGUID: this.getSessionId() } })
            .then((res) => {
                if (res.data.code !== 0) {
                    this.hndlWafError(res.data.code, res.data.message);
                }

                // add positive message
                if (res.data.message) this.hndlWafMessage(res.data.message);

                const rc = res.data;
                if (config.scalar) {
                    rc.data = rc.data[0];
                }
                return rc;
            })
            .catch(this.hndlRequestError);
    }
}

let instance!: RequestClass;

export default function Request(options: RequestOptions): RequestClass {
    if (!instance) instance = new RequestClass(options);
    return instance;
}

export const WxRequest = () => instance;
